import { render } from "./StatsBlockForm.vue?vue&type=template&id=4dbebd50"
import script from "./StatsBlockForm.vue?vue&type=script&lang=js"
export * from "./StatsBlockForm.vue?vue&type=script&lang=js"

import exportComponent from "/Users/francois/WebstormProjects/crema-manager-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__